import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Sparkles } from 'lucide-react';
export function Pricing() {
  const inclusions = ['Comprehensive role discovery and alignment', 'Rigorous candidate sourcing and vetting', 'English proficiency and technical assessments', 'Curated shortlist within 5–10 business days', 'Interview coordination and offer facilitation', '90-day replacement guarantee', 'Ongoing support during the first 90 days'];
  const tiers = [{
    level: 'Entry Level',
    price: '$1,500',
    featured: false
  }, {
    level: 'Mid-Level',
    price: '$2,000',
    featured: true
  }, {
    level: 'Senior Level',
    price: '$3,000',
    featured: false
  }];
  return <section id="pricing" className="py-24 bg-white" data-id="element-188">
      <div className="max-w-7xl mx-auto px-6" data-id="element-189">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-190">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6 text-navy" data-id="element-191">
            Pricing Built Around Your Hire
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-slate-600" data-id="element-192">
            Transparent, success-based partnerships with no surprise costs.
          </motion.p>
        </div>

        {/* Pricing Tiers */}
        <div className="max-w-5xl mx-auto mb-6" data-id="element-193">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-194">
            {tiers.map((tier, index) => <motion.div key={tier.level} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className={`relative rounded-3xl p-8 text-center ${tier.featured ? 'bg-brand-gradient text-white shadow-soft-lg md:-translate-y-3' : 'bg-slate-50 border border-slate-100'}`} data-id="element-195">
                {tier.featured && <span className="absolute top-4 right-4 text-[10px] font-bold uppercase tracking-wider bg-white/20 text-white px-2.5 py-1 rounded-full" data-id="element-196">
                    Most Common
                  </span>}
                <div className={`text-sm font-semibold uppercase tracking-wider mb-4 ${tier.featured ? 'text-white/80' : 'text-slate-500'}`} data-id="element-197">
                  {tier.level}
                </div>
                <div className={`text-xs font-medium mb-1 ${tier.featured ? 'text-white/70' : 'text-slate-400'}`} data-id="element-198">
                  Starting At
                </div>
                <div className={`text-4xl font-display font-bold ${tier.featured ? 'text-white' : 'text-navy'}`} data-id="element-199">
                  {tier.price}
                  <span className={`text-base font-medium ml-1 ${tier.featured ? 'text-white/70' : 'text-slate-400'}`} data-id="element-200">
                    USD
                  </span>
                </div>
              </motion.div>)}
          </div>
          <p className="text-center text-sm text-slate-500 mt-6" data-id="element-201">
            Pricing above applies to selected positions and standard recruitment
            processes.
          </p>
        </div>

        {/* What's Included + Specialized Talent */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-5xl mx-auto bg-white rounded-4xl shadow-soft-lg border border-slate-100 overflow-hidden flex flex-col md:flex-row mt-12" data-id="element-202">
          <div className="p-10 md:p-12 md:w-3/5" data-id="element-203">
            <h3 className="text-2xl font-bold text-navy mb-6" data-id="element-204">
              What's Included in Every Search
            </h3>
            <ul className="space-y-4" data-id="element-205">
              {inclusions.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-206">
                  <CheckCircle2 className="w-6 h-6 text-coral shrink-0" data-id="element-207" />
                  <span className="text-slate-700" data-id="element-208">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-navy p-10 md:p-12 md:w-2/5 flex flex-col justify-center relative overflow-hidden" data-id="element-209">
            <div className="absolute -top-12 -right-12 w-48 h-48 bg-brand-gradient rounded-full blur-3xl opacity-30 pointer-events-none" data-id="element-210" />
            <div className="relative z-10" data-id="element-211">
              <h4 className="text-xl font-bold text-white mb-3" data-id="element-212">
                Need to hire specialized talent?
              </h4>
              <p className="text-slate-300 text-sm mb-6 leading-relaxed" data-id="element-213">
                For executive searches, niche technical roles, confidential
                searches, international hiring, or high-volume recruitment
                projects, we develop a customized solution based on your hiring
                goals, timeline, and talent requirements.
              </p>

              <div className="flex items-center gap-2 mb-2" data-id="element-214">
                <Sparkles className="w-4 h-4 text-pink" data-id="element-215" />
                <span className="text-sm font-bold text-white" data-id="element-216">
                  Custom Recruitment Solutions
                </span>
              </div>
              <p className="text-xs text-slate-400 mb-8" data-id="element-217">
                Tailored pricing. Specialized searches. Exceptional talent.
              </p>

              <a href="https://calendly.com/partners-talvoritalents/30min?month=2026-06" target="_blank" rel="noopener noreferrer" className="w-full inline-flex items-center justify-center px-6 py-4 bg-white text-navy font-semibold rounded-full hover:bg-slate-100 transition-colors shadow-soft" data-id="element-218">
                Book a Free Consultation
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}